<script setup>
import { useQuasar } from 'quasar'
import useLogs from '../../../store/logs.store'
import { callApi, formatTime } from '../../../utils'
import Table from '../../shared/Table.vue'
import { useI18n } from "vue-i18n"
const { t } = useI18n()

const {
  logs,
  getLogs,
  loading,
  pagination,
  filterOptions
} = useLogs()

const $q = useQuasar()

const columns = [
  { name: 'createdAt', align: 'left', label: t("table.columns.createdAt"), field: 'createdAt', format: v => formatTime(v) },
  { name: 'deviceId', align: 'left', label: t("device.id"), field: 'deviceId' },
  { name: 'msg', align: 'left', label: t("logs.msg"), field: 'msg' },
]

function paginate (props) {
  callApi([getLogs], {
    ...filterOptions.value,
    page: parseInt(props.pagination.page),
    "page-size": parseInt(props.pagination.rowsPerPage)
  }, $q, loading)
}

callApi([getLogs], {
  'page-size': parseInt(pagination.value.rowsPerPage)
}, $q, loading)
console.log("Role list: ", logs);
</script>

<template lang='pug'>
.role-list
  Table(
    :title='t("menu.logs")'
    :rows='logs'
    :loading='loading'
    :columns='columns'
    row-key='_id'
    v-model:pagination="pagination"
    @request="paginate"
    @row-click='showUpdate'
  )
    template(v-slot:header='props')
      q-th(v-for="(col, index) in props.cols" :key="col.name")
        div {{ col.label }}
        
    template(v-slot:body="props")
      q-td(v-for="col in props.cols" :key="col.name")
        div
          | {{ col.value }}
</template>
